import { render, staticRenderFns } from "./common-icon.vue?vue&type=template&id=3a83f0e0&scoped=true&"
import script from "./common-icon.vue?vue&type=script&lang=js&"
export * from "./common-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a83f0e0",
  null
  
)

export default component.exports